/**
 * Timezone-neutral ordinal for comparing calendar dates (same day => same value).
 * Uses UTC as a numeric bucket; components are read from the Date in local time.
 */
export function calendarDateMs(date: Date): number {
  return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
}
